// assets/announcement-bar-free-shipping.js

var bars = document.querySelectorAll('[data-free-shipping-threshold]');

bars.forEach(function(bar) {
  var thresholdCents = parseInt(bar.getAttribute('data-free-shipping-threshold'), 10);
  if (isNaN(thresholdCents)) return;

  var formatted = Shopify.showPrice(thresholdCents);

  bar.querySelectorAll('.announcement-bar__message').forEach(function(msg) {
    msg.innerHTML = msg.innerHTML.replace(/\[free_shipping\]/g, formatted);
  });
});
